/* __next_internal_client_entry_do_not_use__ Undo auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=3812%3A466))
 * @trackcomponent
 * @lastsynced 2023-08-15T21:03:21.605Z
 */ export var Undo = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M5.99979 2.57153L0.856934 7.71439L5.99979 12.8572",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M0.856934 7.71436H16.2855C18.1041 7.71436 19.8483 8.4368 21.1342 9.72277C22.4202 11.0087 23.1426 12.7529 23.1426 14.5715C23.1426 16.3901 22.4202 18.1343 21.1342 19.4202C19.8483 20.7062 18.1041 21.4286 16.2855 21.4286H7.71408",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "Undo", {
    color: Core.icon.default,
    fill: "none",
    viewBox: "0 0 24 24"
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
